// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rN0ND","collectionItem":"styles_collectionItem__3ivz5","collectionItem__active":"styles_collectionItem__active__2Db09"};